import * as RadixPopover from '@radix-ui/react-popover';
import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Popover({
  trigger,
  children,
  align = 'start',
  sideOffset = 6,
}: {
  trigger: ReactNode;
  children: ReactNode;
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
}) {
  return (
    <RadixPopover.Root>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          align={align}
          sideOffset={sideOffset}
          className={cn(
            'z-50 rounded-xl border border-line bg-white shadow-lift p-2',
            'min-w-[200px] animate-scale-in origin-top',
          )}
        >
          {children}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
